module.exports = __webpack_public_path__ + "bc94944a12ba8cb55c08ce82f9e3ed06.png";